// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WhereCanYouPlay_wrapper__YBku9","section":"WhereCanYouPlay_section__I449X","title":"WhereCanYouPlay_title__XOmEF","content":"WhereCanYouPlay_content__A0k9i"};